var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeGlassesPoorVisionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2711 14.3156L3 51.8889M60.7778 7.44444H69.6667L83 51.8889M34.1111 60.7778H51.8889M76.0045 75.9911C73.6592 77.5367 70.9392 78.4185 68.1332 78.5429C65.3271 78.6673 62.5398 78.0295 60.067 76.6974C57.5942 75.3653 55.5282 73.3886 54.0883 70.9769C52.6485 68.5653 51.8884 65.8088 51.8889 63V51.8889M69.6667 51.8889H83V63C83 63.6978 82.9556 64.3867 82.8667 65.0578M3 3L83 83M34.1111 63C34.1111 67.1256 32.4722 71.0822 29.555 73.9994C26.6378 76.9167 22.6811 78.5556 18.5556 78.5556C14.43 78.5556 10.4734 76.9167 7.55612 73.9994C4.63889 71.0822 3 67.1256 3 63V51.8889H34.1111V63Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGlassesPoorVisionIcon);
export default __webpack_public_path__ + "static/media/eyeGlassesPoorVisionIcon.a2fc355778285846f6d28ccc75e55276.svg";
export { ForwardRef as ReactComponent };